enum ApiMethodType {
    Get = 'get',
    Delete = 'delete',
    Post = 'post',
    Put = 'put',
}

export default ApiMethodType;
